import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '@/index.scss'

// plugins
import VueClickAway from 'vue3-click-away'
import SkynamoTooltip from 'SkynamoDesignSystem/SkynamoTooltip'

// components
import App from '@/App.vue'

const app = createApp(App)

app
  .use(createPinia())
  .use(VueClickAway)
  .use(SkynamoTooltip)
  .mount('#app')
